import gsap from "gsap";
import { module as BaseModule } from "modujs";
import Swiper from "swiper";
import { Keyboard, Navigation, Pagination } from "swiper/modules";

import "swiper/css"; //eslint-disable-line
import "swiper/css/navigation"; //eslint-disable-line
import "swiper/css/pagination"; //eslint-disable-line

const WPVR_NO_SWIPE_SELECTOR = ".wpvr-cardboard, .pano-wrap, .pnlm-container, [id^='pano']"

export default class extends BaseModule {
  updateArchiveSwiping(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex]
    const isWpvrSlide = Boolean(activeSlide?.querySelector(WPVR_NO_SWIPE_SELECTOR))

    swiper.allowTouchMove = !isWpvrSlide
  }

  init() {
    const slider = this.el
    const { sliderConfig } = slider.dataset

    const params = {
      default: {
        modules: [Keyboard, Navigation],
        draggable: true,
        slidesPerView: "auto",
        spaceBetween: 16,
        grabCursor: true,
        navigation: {
          nextEl: document.querySelector("[data-slider-next]"),
          prevEl: document.querySelector("[data-slider-prev]"),
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
      },
      archive: {
        modules: [Navigation, Keyboard],
        draggable: true,
        slidesPerView: "1",
        loop: true,
        grabCursor: true,
        noSwipingSelector: WPVR_NO_SWIPE_SELECTOR,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation: {
          nextEl: "[data-slider-next]",
          prevEl: "[data-slider-prev]",
        },
        on: {
          init: (instance) => {
            this.updateArchiveSwiping(instance)
          },
          slideChange: (instance) => {
            this.updateArchiveSwiping(instance)

            const current = document.querySelector("[data-slider-active-cell]")
            const currentIndex = instance.realIndex + 1
            if (current) {
              current.innerHTML = currentIndex
            }
          },
        },
      },
    }

    this.swiper = new Swiper(slider, params[sliderConfig])
    gsap.to(slider, {
      opacity: 1,
      duration: 3,
      ease: "power2.Out",
    })

    if (sliderConfig === "archive" && window.innerWidth > 900) {
      const enlarge = document.querySelector("[data-slider-enlarge]")
      enlarge?.addEventListener("click", () => {
        document.documentElement.classList.add("is-zoomed")
      })

      const close = document.querySelector("[data-archive-zoom-close]")
      close.addEventListener("click", () => {
        document.documentElement.classList.remove("is-zoomed")
      })
    }
  }
}
